import { render, staticRenderFns } from "./Notenuebersicht.vue?vue&type=template&id=29a61f37&scoped=true&"
import script from "./Notenuebersicht.vue?vue&type=script&lang=js&"
export * from "./Notenuebersicht.vue?vue&type=script&lang=js&"
import style0 from "./Notenuebersicht.vue?vue&type=style&index=0&id=29a61f37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a61f37",
  null
  
)

export default component.exports